import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'

import { Card } from '@/components/ui/card'
import { Pagination } from '@/components/ui/pagination'
import { Skeleton } from '@/components/ui/skeleton'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { getAuditLogs } from '@/services/api/workspace-settings.service'
import { formatDateTime } from '@/utils/date'

const label = (action: string) => action.toLowerCase().replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase())

/** Who did what to the workspace, newest first. */
export function AuditLogTab() {
  const [page, setPage] = useState(0)
  const { data, isLoading } = useQuery({ queryKey: ['workspace-audit', page], queryFn: () => getAuditLogs(page), placeholderData: (p) => p })

  if (isLoading) return <Skeleton className="h-48 w-full" />
  const rows = data?.content ?? []
  return (
    <div className="space-y-3">
      <Card className="overflow-x-auto shadow-none">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>When</TableHead>
              <TableHead>Who</TableHead>
              <TableHead>What</TableHead>
              <TableHead>Details</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.length === 0 && (
              <TableRow><TableCell colSpan={4} className="py-8 text-center text-muted-foreground">Nothing recorded yet.</TableCell></TableRow>
            )}
            {rows.map((row) => (
              <TableRow key={row.id}>
                <TableCell className="whitespace-nowrap">{formatDateTime(row.createdAt)}</TableCell>
                <TableCell>{row.userName ?? 'System'}</TableCell>
                <TableCell>{label(row.action)}</TableCell>
                <TableCell className="max-w-xs truncate text-muted-foreground" title={JSON.stringify(row.details)}>
                  {Object.entries(row.details ?? {}).filter(([k]) => k !== 'occurredAt').map(([k, v]) => `${k}: ${String(v)}`).join(', ')}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
      {data && data.totalPages > 1 && (
        <Pagination page={data.page} size={data.size} totalElements={data.totalElements} totalPages={data.totalPages} onPageChange={setPage} itemLabel="entries" />
      )}
    </div>
  )
}
